import AxiosService from "../AxiosService";

export class LoginService {
  constructor() {
    this.service = new AxiosService();
  }

  resolveUser() {
    return this.service.get(`/api/user`);
  }
}
